"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fusion_1 = require("../../core/fusion");
var kflowerPassengerConfig = {
    android: {
        factory: fusion_1.default,
        options: {},
    },
    ios: {
        factory: fusion_1.default,
        options: {},
    },
};
exports.kflowerPassenger = kflowerPassengerConfig;
exports.default = kflowerPassengerConfig;
